import Item from '@/models/Item';
import ItemStatus from './ItemStatus';

class ItemStatusCalculator {
  static determineItemStatus(item: Item): ItemStatus {
    if (!item.state) return ItemStatus.UNATTEMPTED;

    const state = JSON.parse(item.state);
    if (!state['attempted']) return ItemStatus.UNATTEMPTED;

    const attempted: boolean[] = [];
    const ids = Object.keys(state['attempted']);
    for (let i = 0; i < ids.length; i++) {
      attempted.push(state['attempted'][ids[i]]);
    }
    //console.log(attempted);

    // All true
    if (!attempted.includes(false)) return ItemStatus.FULLY_ATTEMPTED;

    // All false
    if (!attempted.includes(true)) return ItemStatus.UNATTEMPTED;

    // Mixed
    return ItemStatus.PARTIALLY_ATTEMPTED;
  }
  static allMatch(itemStatusArray: Array<ItemStatus>, itemStatus: ItemStatus): boolean {
    return itemStatusArray.filter((value) => value === itemStatus).length === itemStatusArray.length;
  }
}

export default ItemStatusCalculator;
